import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { sendGa } from 'analytics/analytics';

import { InfoPage } from 'components/common/Layout/InfoPage/InfoPage';
import { getField } from 'components/form-multi/utils';

import { setNewForm } from 'actions/formAction';

import { STATUS_OK } from 'constants/Constants';
import { SMS_ON_SUCCESS_PAY_FORM_NAME } from 'constants/formName';
import { TRANSACTION_SUCCESSFUL } from 'constants/GoogleAnalyticsEvents';
import { AUTH_PAY_NOTIFICATION_ACTION, AUTH_SEND_MAIN_LINK } from 'constants/UrlConstants';

import { useExtra, usePageMessages } from 'hooks/selectors';

import BaseLayoutPromo from '../components/no-auth/common/BaseLayoutPromo';
import PromoFailed from '../components/no-auth/common/PromoStatus/PromoFailed';
import Success from '../components/sharedComponents/status/Success';
import Waiting from '../components/sharedComponents/status/Waiting';
import BasePageForNoAuth from '../components/utils/BasePageForNoAuth';
import ModalNew from '../components/utils/ModalNew';

function useGoogleAnalytics(status) {
    useEffect(() => {
        if (__isBrowser__) {
            window.addEventListener(
                'load',
                function () {
                    if (window.ga) {
                        if (status && status.status <= STATUS_OK) {
                            sendGa(TRANSACTION_SUCCESSFUL, TRANSACTION_SUCCESSFUL);
                        }
                    }
                },
                { once: true },
            );
        }
    }, []);
}

const StatusNoAuthPage = (props) => {
    const messages = usePageMessages();
    const modalRef = useRef();
    const { special_error_code, show_additional_check_button } = useExtra();

    const getStatus = () => {
        return props.data?.status ? props.data?.status : props.data?.extra?.payment_status;
    };

    useEffect(() => {
        if (props.data.smsOnSuccessPay) {
            props.setNewForm(
                SMS_ON_SUCCESS_PAY_FORM_NAME,
                {
                    id: getField('id', props.data.smsOnSuccessPay.id, null, true, false),
                    phone: getField('phone', '', null, true, false, messages.sendPhonePlaceholder, 'tel'),
                    text: getField('text', messages.sendTextText, null, true, false, messages.sendTextPlaceholder, 'text'),
                },
                AUTH_PAY_NOTIFICATION_ACTION,
            );
        }
    }, []);

    const status = getStatus();

    useGoogleAnalytics(status);

    if (special_error_code) {
        return (
            <InfoPage
                animatedIconFail
                headerText={messages.error_title}
                secondaryText={messages.error_description}
                primaryButtonType="reactLink"
                primaryButtonCaption={show_additional_check_button ? messages.additional_check_button : ''}
                primaryButtonLink={`/auth/user-error?code=${special_error_code}`}
                topButtonCaption={messages.cancelText}
                topButtonType="link"
                topButtonLink={AUTH_SEND_MAIN_LINK}
            />
        );
    } else {
        return (
            <BaseLayoutPromo>
                {status && status.status > STATUS_OK && <PromoFailed status={status} />}
                {status && status.status === STATUS_OK && (
                    <Success
                        smsOnSuccessPay={props.data.smsOnSuccessPay}
                        showSendSMSNotificationBlock={status.showSendSMSNotificationBlock}
                        status={status}
                        modalRef={modalRef}
                    />
                )}
                {(!status || status?.status < STATUS_OK) && <Waiting smsOnSuccessPay={props.data.smsOnSuccessPay} status={status} />}
                <ModalNew ref={modalRef} />
            </BaseLayoutPromo>
        );
    }
};

export default connect(null, { setNewForm })(BasePageForNoAuth(StatusNoAuthPage));
